import { useState, useEffect } from 'react';
import { useLoggedIn } from 'bv-hooks';
import { fetchBetsCount } from '../api';
import { subscribeToEventBets } from '../subscribers';

export const useEventBetsCount = (eventId) => {
  const [count, setCount] = useState(0);
  const loggedIn = useLoggedIn();

  const fetchCount = () => fetchBetsCount(eventId).then((response) => setCount(response.count));

  useEffect(() => {
    if (loggedIn) {
      fetchCount();
    }
  }, [eventId, loggedIn]);

  useEffect(() => {
    if (!loggedIn) return undefined;

    return subscribeToEventBets(parseInt(eventId, 10), {
      new: () => setCount(count + 1),
      // settled bet message does not contain the legs event information,
      // so we need to fetch the bet count for the event again
      settled: fetchCount,
    });
  }, [count, eventId, loggedIn]);

  return count;
};
